<div class="w100 row space-between align-center" i18n>
    <h2>Edit Login Forms</h2>
    <rr-btn
        type="Primary"
        iconStart="add"
        size="Small"
        (click)="createLoginForm()"
        [disabled]="!!loginForm.length">
        New Login Form
    </rr-btn>
</div>

<div class="col w100 grow-1 gap-24 login-forms" [class.justify-center]="!loginForm.length" i18n>
    <div class="col w100 gap-8" [class.card]="loginForm.length" [class.align-center]="!loginForm.length">
        @for (form of loginForm; track form; let i = $index) {
            <div class="w100 cold gap-4 form-wrapper">
                <!-- TODO: remove any -->
                <div class="row w100 align-center space-between">
                    <span>{{ $any(form).id }}</span>
                    <rr-checkbox
                        [disabled]="!$any(form).isCustom"
                        [(ngModel)]="$any(form).active"
                        [checked]="$any(form).active">
                        Is Active
                    </rr-checkbox>

                    <rr-checkbox
                        [disabled]="!$any(form).isCustom"
                        [(ngModel)]="$any(form).required"
                        [checked]="$any(form).required">
                        Is Required <sup>(*)</sup>
                    </rr-checkbox>
                </div>
            </div>
        } @empty {
            <div class="col h100 grow-1 align-center justify-center">
                <div>No forms for this company</div>
                <rr-btn type="Primary" size="Medium" (click)="createLoginForm()">
                    + New Form
                </rr-btn>
            </div>
        }

        @if (loginForm.length) {
            <div class="row w100 justify-end align-center delete-form">
                <rr-btn
                    type="Link"
                    iconStart="trash"
                    (click)="deleteLoginForm()">
                    Delete Form
                </rr-btn>
            </div>
        }
    </div>
</div>

<div class="w100 gap-8 justify-end row" i18n>
    <rr-btn type="Secondary" (click)="close()">
        Cancel
    </rr-btn>
    <rr-btn type="Primary" (click)="save()" [disabled]="loginForm.length === 0">
        Add to Invite-Link
    </rr-btn>
</div>
